module.exports = __webpack_public_path__ + "img/box-packaging-0@1x.03493602.png";